export default "/images/c7066b5e485581466c08610d05690300.avif";